import { useGetIdsListQuery } from "../store/api/filmAPI";
import useShared from "../utils/hooks/useShared";

const useShareClick = () => {
  const token = localStorage.getItem("accessToken");

  const { saveCountHandler } = useShared();

  const shareList = useGetIdsListQuery({
      mainFilter: "/movies/shares/ids",
      queries: {}
    },
    {
      skip: !token,
    });

  const shareHandler = async (e: any, item: any, shared: boolean) => {
    e.stopPropagation();
    if (!token) return;

    if (!shared) {
      await saveCountHandler(item);
    }

    shareList.refetch();
  }

  return {
    shareList,
    shareHandler
  }
};

export default useShareClick;
